import { Injectable, signal, inject } from "@angular/core";
import { LorenError } from "./loren-error.enum";
import { HttpErrorResponse } from "@angular/common/http";
import { LorenSnackBarService } from "../loren-snack-bar-service/loren-snack-bar.service";
import { TranslocoService } from "@jsverse/transloco";

@Injectable({
  providedIn: "root",
})
export class LorenErrorHandlingService {
  private snackbarService = inject(LorenSnackBarService);
  private transloco = inject(TranslocoService);

  loading = signal<boolean>(false);
  globalError = signal<LorenError>(null);

  setGlobalError(err: HttpErrorResponse) {
    this.loading.set(false);
    if (err.status === 403) {
      this.globalError.set(LorenError.FORBIDDEN);
    } else if (err.status === 404) {
      this.globalError.set(LorenError.NOT_FOUND);
    } else if (err.status >= 500 && err.status < 600) {
      this.globalError.set(LorenError.SERVICE_ERROR);
    }
  }

  setSuccess() {
    this.loading.set(false);
    this.globalError.set(null);
  }

  showSnackbarError(errorMessage = null) {
    this.snackbarService.showErrorMessage(
      errorMessage ||
        this.transloco.translate("error_page.general_error_message")
    );
  }
}
